import { useCallback } from 'react';
const STYLE_ID = 'hs-portals-theme-styles';
const DYNAMIC_CLASS_PATTERN = /^hs-form-[0-9a-f-]+_[0-9a-f-]+$/;
function findDynamicFormClass(doc) {
  const form = doc.querySelector('form.hs-form');
  if (!form) return null;
  for (const cls of form.classList) {
    if (DYNAMIC_CLASS_PATTERN.test(cls)) return cls;
  }
  return null;
}
export function useInjectIframeStyles(containerId, buildCss) {
  return useCallback(() => {
    var _iframe$contentDocume, _iframe$contentWindow;
    const container = document.getElementById(containerId);
    const iframe = container === null || container === void 0 ? void 0 : container.querySelector('iframe');
    const doc = (_iframe$contentDocume = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) !== null && _iframe$contentDocume !== void 0 ? _iframe$contentDocume : iframe === null || iframe === void 0 || (_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document;
    if (!doc) return;
    const dynamicClass = findDynamicFormClass(doc);
    if (!dynamicClass) return;
    const css = buildCss(dynamicClass);
    const existing = doc.getElementById(STYLE_ID);
    if (existing) {
      existing.textContent = css;
      return;
    }
    const style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    doc.head.appendChild(style);
  }, [containerId, buildCss]);
}